import React, { useContext, useEffect, useState } from "react";
import Image from "../../../elements/Image";
import Switcher from "../../../elements/Switcher";
import ProfileImage from "../../../../assets/images/pexels-enginakyurt-1642228.jpg";
import Image01 from "../../../../assets/images/event-05.webp";
import Image02 from "../../../../assets/images/hip-hop-style.webp";
import Image03 from "../../../../assets/images/event-04.webp";
import { classNames } from "../../../../helpers/classNames";
import Button from "../../../form/Button";
import { useQuery } from "@tanstack/react-query";
import { profileDetails } from "../../../../services/ProfileService";
import { useSelector } from "react-redux";
import { lngDetect } from "../../../../helpers/lngDetect";
import Indentification from "../../../elements/Indentification";
import { initialsValue } from "../../../../helpers";
import ProfileDetailsModal from "./ProfileDetailsModal";
import SocketContext, { useSocket } from "../../../../context/SocketContext";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const HubSidepanel = ({
  selectedProfile = {},
  setSelectedProfile = () => {},
  totalEvents,
}) => {
  const { selectedOrganization, organizations, selectedOrganizationDetails } =
    useSelector((state) => state?.organization);
  const { lang } = useSelector((state) => state?.langProvider);
  const navigate = useNavigate();
  const [userOnlineStatus, setUserOnlineStatus] = useState(true);
  const [messages, setMessages] = useState({ count: 0 });
  const { socket } = useContext(SocketContext);
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (socket?.connected && session?.user?._id) {
      socket?.emit("messageUnreadCountEvent", { user: session?.user?._id });
    }
  }, [session?.user?._id]);

  useSocket(
    "messageUnreadCountEventResponse",
    (res) => {
      if (session?.user?._id === res?.user && res?.countFor !== "event") {
        setMessages((pre) => ({ ...pre, count: res?.data }));
      }
    },
    [session?.user?._id]
  );

  useSocket(
    "getMessageDetailEventResponse",
    (res) => {
      socket?.emit("messageUnreadCountEvent", { user: session?.user?._id });
    },
    [session?.user?._id]
  );

  useEffect(() => {
    setTimeout(() => {
      setUserOnlineStatus(!userOnlineStatus);
    }, 5000);
  }, [userOnlineStatus]);

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const res = await profileDetails();
      return res?.data;
    },
  });

  const moderationDropdownData = [
    {
      value: profile?._id,
      name: `${profile?.firstName || ""} ${profile?.lastName || ""}`,
      role: profile?.role,
      description: "profile",
      image: profile?.image?.url,
    },
    ...(organizations?.data?.data || [])?.map((org) => ({
      value: org?.organizationData?._id,
      name: lngDetect(org?.organizationData?.name),
      role: org?.role,
      description: "organization",
      image: org?.organizationData?.logo?.url,
    })),
  ];

  useEffect(() => {
    if (moderationDropdownData?.length > 0 && !selectedProfile?.value) {
      setSelectedProfile(moderationDropdownData?.[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(moderationDropdownData), selectedProfile]);

  return (
    <>
      <div className="-mt-20">
        {/* <div className="w-40 aspect-square rounded-full overflow-hidden border-4 border-white shadow-lg flex-shrink-0">
          <Image
            src={ProfileImage}
            alt="no-data"
            classes="object-cover object-top"
          />
        </div> */}
        <div className="w-40 aspect-square rounded-full overflow-hidden border-4 border-white shadow-lg flex-shrink-0 bg-white">
          <Indentification
            image={selectedProfile?.image}
            alt={selectedProfile?.image || selectedProfile?.name}
            initial={initialsValue(selectedProfile?.name)}
            className={"overflow-hidden"}
            size="max"
            initialClass={"text-[50px] font-semibold"}
          />
        </div>
        <div className="py-4">
          <div className="flex items-center space-x-2">
            <div className="w-full max-w-60">
              <Switcher
                dropdownData={moderationDropdownData}
                dropdownClass={"!w-80 !border-0"}
                selectedValue={selectedProfile}
                onChange={(val, item) => {
                  setSelectedProfile(item);
                }}
              />
            </div>
            <div
              className={classNames(
                "flex-shrink-0 w-2 aspect-square rounded-full",
                userOnlineStatus ? "bg-green-500" : "bg-gray-400"
              )}
            />
          </div>
          <div className="space-y-2">
            <div className="relative flex items-center justify-between">
              <div className="text-sm text-gray-500">
                {selectedProfile?.description || ""}
              </div>
              <div className="flex items-center gap-3">
                {selectedProfile?.description === "organization" && (
                  <div className="flex-shrink flex-grow whitespace-nowrap">
                    <div className="text-sm text-gray-800">
                      <strong>{totalEvents}</strong> {t("events")}
                    </div>
                  </div>
                )}
                <div className="flex-shrink-0">
                  <Button
                    buttonLabel={`${t("Message")} ${
                      messages?.count > 0 ? messages?.count : ""
                    }`}
                    buttonIcon={"fa-light fa-comment text-sm"}
                    buttonIconPosition="left"
                    buttonClasses={"!h-7 !px-3"}
                    buttonLabelClasses={"!capitalize !font-normal text-sm"}
                    buttonFunction={() =>
                      navigate(`/${lang}/user/communication`)
                    }
                  />
                </div>
              </div>
            </div>
            <ProfileDetailsModal selectedProfile={selectedProfile} />
          </div>
        </div>
      </div>
    </>
  );
};

export default HubSidepanel;
